const TRANSLATE_DATA = {
  zh: '中文',
  en: '英文',
  th: '泰语',
  vi: '越南语',
  ms: '马来语',
  id: '印度尼西亚语',
  ja: '日语',
  pt: '葡萄牙语',
  es: '西班牙语',
  de: '德语',
  fr: '法语',
  ko: '韩语',
  ru: '俄语',
  ar: '阿拉伯语',
  bn: '孟加拉语',
  hi: '印地语',
  fil: '菲律宾语',
  lo: '老挝语',
  tr: '土耳其语',
  nl: '荷兰语',
  zu: '祖鲁语',
  pl: '波兰语',
  it: '意大利语',
  fa: '波斯语',
  km: '柬埔寨语',
  my: '缅甸语',
  'zh-tw': '繁体中文'
};

export default TRANSLATE_DATA;
